import ConnectedAccessoriesSummaryPanel from './AccessoriesSummaryPanel';

export default ConnectedAccessoriesSummaryPanel;
